import React from 'react';

export function useActionsByType(actions=[]) {
	return React.useMemo(() => {
		return actions.reduce((actions, action) => {
			actions[action.type] = { ...action };
			return actions;
		}, {});
	}, [actions]);
}

export function APIAction({ name, actions=[], children }) {
	const actions_by_type = useActionsByType(actions);

	if(!(name in actions_by_type)) {
		return null;
	}

	const { enabled, config={}, metadata={} } = actions_by_type[name];
	return React.cloneElement(children, {
		...children.props,
		disabled: !enabled,
		config,
		metadata,
	});
}
